module.exports = __webpack_public_path__ + "img/家电行业数字化转型场景图谱.920e0294.jpg";